import React, { Component } from "react";
import { AuthContext } from './Auth/Auth'
import axios from "axios";
import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";
import "jquery.soap";
import { Form } from "semantic-ui-react";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const CloseButton = ({ YouCanPassAnyProps, closeToast }) => (
  <i className="close icon" onClick={closeToast}></i>
);

const Toaster = () => (
  <ToastContainer
    closeOnClick
    hideProgressBar
    closeButton={<CloseButton YouCanPassAnyProps="foo" />}
    position={toast.POSITION.TOP_RIGHT}
    autoClose={6000}
    newestOnTop={false}
    rtl={false}
    pauseOnFocusLoss
    draggable
    pauseOnHover
  />
);

const dataInit = {
  CepCodigo: "",
  CodigoEstado: "",
  NomeBairro: "",
  NomeCidade: "",
  NomeEstado: "",
  NomeLogradouro: "",
  NomePais: "",
  SiglaEstado: "",
  SiglaPais: "",
  Complemento: "",
  Numero: ""
}

export class NewMasterForm extends Component {

  static contextType = AuthContext;

  constructor(props) {
    super(props);

    this.state = {
      currentStep: 1,
      sucesso: false,
      msgErro: "",
      open:false,
      codLoja:"",
      idParceria: "",
      optionsMarcas:[],
      optionsModelos:[],
      optionsCores:[],
      marcaInfo:[],
      modeloInfo:[],
      corInfo:[],
      updateCompo:false,
      response:false,
      dataCep: dataInit,


      acao:"i",
      nomeCondominio: "",
      cpf: "",
      cep: "",
      rg: "",
      nomeCompleto: "",
      email: "",
      telefone: "",
      anoFabricacao: "",
      modeloAno: "",
      placa: "",
      marcaId:"",
      modeloId:"",
      corId:"",
      marcaCarro:[],
      modeloCarro:[],
      corCarro:[],
      numberTag: "",
      updateTag:""
    };
  }

  handleChange = event => {
    const { name, value } = event.target;
    this.setState({ [name]: value }, () => {
      this.buscarCep();
    });
  };

  buscarCep = () => {
    if(this.state.cep.length < 8) {
      return;
    } else{

      let data = {
        cep: this.state.cep.replace('-', '')
      }

      axios.post('https://prod.apisemparar.com.br/condominio-parceiros/v1/dne/logradouro', data, {
          headers: {
              'x-api-key': 'flA2resqZ43x2E1k5uYOBGjfCiMwtAV1v2vsTjtc'
          }
      })
      .then(res => {
          this.setState({ dataCep: res.data.dados })
          console.log('STATE2 ', this.state)
      })
      .catch(error => {
          setTimeout(() => {
              this.setState({ open: false });
              this.mensagemError("Por favor verifique se os dados estão corretos e tente novamente. Se persistir o erro, entre em contato com seu administrador.");
          }, 2050)
      });
    }
  }

  inputSelectMarca = () => {

    const URL = process.env.REACT_APP_URL_MARCA_CARRO;
    const X_API_KEY = process.env.REACT_APP_X_API_KEY_CAR_INFO;

    const headers = {
      "x-api-key": X_API_KEY,
      "Content-Type":"application/json"
    }

    const data = JSON.stringify({
      tipoVeiculo: 1
    });

    axios.post(URL, data, {
      headers: headers
    })
    .then(response => {

      const marcas = response.data.listaMarcasVeiculo.map(function(row) {
        return { value : row.identificadorMarcaVeiculo, label : row.descricao}
      });
      this.setState({ optionsMarcas: marcas});
    })
    .catch(error => {
      console.log(error);
    });
  }

  inputSelectModelo = selectedOption => {

    if(selectedOption){
      this.setState({
        marcaCarro:selectedOption.label
      })
      this.setState({
        marcaInfo:{ identificadorMarcaVeiculo:selectedOption.value, descricao:selectedOption.label }
      })
    }

    const URL = process.env.REACT_APP_URL_MODELO_CARRO;
    const X_API_KEY = process.env.REACT_APP_X_API_KEY_CAR_INFO;

    const headers = {
      "x-api-key":X_API_KEY,
      "Content-Type":"application/json"
    }

    const data = JSON.stringify({
      tipoVeiculo: 1,
      identificadorMarcaVeiculo: selectedOption ? selectedOption.value : this.state.marcaId

    });

    axios.post(URL, data, {
      headers: headers
    })
    .then(response => {
      const modelos = response.data.listaModeloVeiculo.map(function(row) {
        return { value : row.identificadorModeloVeiculo, label : row.descricao }
      });
      this.setState({ optionsModelos: modelos});
    })
    .catch(error => {
      console.log(error);
    });
  }

  inputSelectCor = selectedOption => {
    if(selectedOption){
      this.setState({
        modeloCarro: selectedOption.label
      })
      this.setState({
        modeloInfo: {
          identificadorModeloVeiculo: selectedOption.value,
          descricao: selectedOption.label
        }
      })
    }

    const URL = process.env.REACT_APP_URL_COR_CARRO;
    const X_API_KEY = process.env.REACT_APP_X_API_KEY_CAR_INFO;

    const headers = {
      "x-api-key":X_API_KEY,
      "Content-Type":"application/json"
    }

    axios.get(URL, {
      headers: headers
    })
    .then(response => {
      const cores = response.data.listaCor.map(function(row) {
        return { value : row.codigoDominio, label : row.descricao}
      });
      this.setState({ optionsCores: cores});
    })
    .catch(error => {
      console.log(error);
    });
  }


  inputColorSelected =  selectedOption => {
   if(selectedOption){
    this.setState({
      corCarro: selectedOption.label
    });
    this.setState({
      corInfo: {
        identificadorCorVeiculo:selectedOption.value,
        descricao:selectedOption.label
      }
    })
   }
  };

  /************** AQUI ESTAMOS RECEBENDO OS DADOS DO USUÁRIO COMPONENT FILHO STEP1 **********************/
  getDataUpdate(data){
    this.setState({
      acao: "u",
      nomeCondominio: data.codigoCondominio,
      cpf: data.cpf,
      cep: data.cep,
      rg: data.rg,
      nomeCompleto: data.nome.toUpperCase(),
      email: data.email,
      telefone: data.telefone,
      placa: data.placa,
      marcaCarro: data.marcaCarro,
      modeloCarro:data.modeloCarro,
      corCarro:data.corCarro,
      marcaId:data.marcaId,
      modeloInfo: { identificadorModeloVeiculo : data.modeloId, descricao : data.modeloCarro },
      marcaInfo: { identificadorMarcaVeiculo : data.marcaId, descricao : data.marcaCarro },
      corInfo: { identificadorCorVeiculo : data.corId, descricao : data.corCarro },
      numberTag:data.tag,
      updateTag:data.tag
    });
  }

  /************** ACTION BUTTONS **********************/
  _next = () => {
    let currentStep = this.state.currentStep;
    currentStep = currentStep >= 2 ? 3 : currentStep + 1;
    this.setState({
      currentStep: currentStep
    });
  };

  _prev = () => {
    let currentStep = this.state.currentStep;
    currentStep = currentStep <= 1 ? 1 : currentStep - 1;
    this.setState({
      currentStep: currentStep,
      numberTag: ""
    });
  };

  newPage = () => {
    this.setState({
      currentStep: 1,
      sucesso: false,
      msgErro: "",
      open:false,
      optionsModelos:[],
      marcaInfo:[],
      modeloInfo:[],
      corInfo:[],
      updateCompo:false,
      response:false,
      acao:"i",
      nomeCondominio: "",
      cpf: "",
      cep: "",
      rg: "",
      nomeCompleto: "",
      email: "",
      telefone: "",
      placa: "",
      marcaId:"",
      modeloId:"",
      corId:"",
      marcaCarro:[],
      modeloCarro:[],
      corCarro:[],
      numberTag: "",
      updateTag:""
    });
  };

  defaultPage = () => {
    this.setState({
      currentStep: 1
    });
  };

  /************** MENSAGENS ***************************/
  mensagemError(errorString) {
    this.notify = () => toast.error(errorString);
    this.notify();
  }


   /************** MENSAGENS INFO ***************************/
   mensagemInfo(alertString) {
    this.notify = () => toast.info(alertString);
    this.notify();
  }

  /************** VALIDADORES *************************/
  validaEmail(strEmail) {
    var usuario = strEmail.substring(0, strEmail.indexOf("@"));
    var dominio = strEmail.substring(
      strEmail.indexOf("@") + 1,
      strEmail.length
    );

    if (
      usuario.length >= 1 &&
      dominio.length >= 3 &&
      usuario.search("@") === -1 &&
      dominio.search("@") === -1 &&
      usuario.search(" ") === -1 &&
      dominio.search(" ") === -1 &&
      dominio.search(".") !== -1 &&
      dominio.indexOf(".") >= 1 &&
      dominio.lastIndexOf(".") < dominio.length - 1
    ) {
      return true;
    }
    return false;
  }

  validaCPF(strCPF) {
    strCPF = strCPF.replace(/[^0-9]+/g, "");

    var Soma;
    var Resto;
    Soma = 0;
    if (strCPF === "00000000000") return false;

    for (var i = 1; i <= 9; i++)
      Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
    Resto = (Soma * 10) % 11;

    if (Resto === 10 || Resto === 11) Resto = 0;
    if (Resto !== parseInt(strCPF.substring(9, 10))) return false;

    Soma = 0;
    for (i = 1; i <= 10; i++)
      Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
    Resto = (Soma * 10) % 11;

    if (Resto === 10 || Resto === 11) Resto = 0;
    if (Resto !== parseInt(strCPF.substring(10, 11))) return false;
    return true;
  }

  validaRG(rg) {
    try {
      if (rg.length > 0) {
        return true;
      }
    } catch (err) {
      return false;
    }

    return false;
  }

  validaTelefone(strTelefone) {
    try {
      //var phoneRGEX = /^\([1-9]{2}\) (?:[2-8]|9[1-9])[0-9]{3}\-[0-9]{4}$/;
      //var phoneResult = phoneRGEX.test(strTelefone);
      if (true) {
        strTelefone = strTelefone.replace(/[^0-9]+/g, "");

        if (strTelefone.length === 10 || strTelefone.length === 11) {
          return true;
        }
      }
    } catch (err) {
      return false;
    }

    return false;
  }

  validaPlaca(strPlaca) {
    try {
      strPlaca = strPlaca.replace(/[^A-Z0-9]+/g, "");
      if (strPlaca.length === 7) {
        return true;
      }
    } catch (err) {
      return false;
    }

    return false;
  }

  validaTag(strTag) {
    //VERIFICA SE O TAG NAO INICIA COM 07
    if (strTag.substring(0, 2) !== "07") {
      this.mensagemError("Número de Dispositivo Inválido");
      return;
    } else {
      //VERIFICA SE POSSUI MAIS DE 11 DIGITOS
       if (strTag.length > 11) {
        this.mensagemError("Número de Dispositivo Inválido");
      } else if (strTag.length < 10) {
        this.mensagemError("Número de Dispositivo Inválido");
      } else{

        if (strTag.length === 11) {
          strTag = strTag.substring(0, 10);
        }

        const API_KEY_TAG = process.env.REACT_APP_X_API_KEY_TAG;
        const APP_URL_IDENTIFICADOR = process.env.REACT_APP_URL_TAG_IDENTIFICADOR;
        const APP_COD_LOJA = this.state.codLoja;
        const TAG_VALIDATOR_URL = 'https://labs.apisemparar.com.br/controleacesso/v1/valida';
        const USER_VALIDATOR_URL = 'https://labs.apisemparar.com.br/controleacesso/v1/busca';
        const ANO_MES_DIA = new Date().toISOString().slice(0, 10);

        const headers = {
          "Content-Type": "application/json",
          "x-api-key": API_KEY_TAG
        };

        var data = JSON.stringify({
          data: ANO_MES_DIA,
          identificador: strTag,
          codigoLoja: APP_COD_LOJA,
          idOfertaComercial: "40190"
        });

        // console.log(data)

/************** VALIDA PRIMEIRO A TAG SE EXISTE NA BASE *************************/
        let config = {
          headers: {
            'Content-Type': 'application/json',
            "x-api-key": 'flA2resqZ43x2E1k5uYOBGjfCiMwtAV1v2vsTjtc'
          },

        };

        const data2 = {
          "contrato": {
              "tag": this.state.numberTag,
              "cliente": {
                  "cpf": this.state.cpf.match(/\d/g).join(""),
                  "rg": this.state.rg,
                  "nome": this.state.nomeCompleto,
                  "endereco": {
                      "logradouro": this.state.dataCep.NomeLogradouro,
                      "complemento": this.state.complemento,
                      "numero": this.state.numero,
                      "bairro": this.state.dataCep.NomeBairro,
                      "cidade": this.state.dataCep.NomeCidade,
                      "uf": this.state.dataCep.SiglaEstado,
                      "cep": this.state.cep
                  },
                  "email": this.state.email,
                  "dddCelular": "11",
                  "celular": "991543456",
                  "dddTelefone": "11",
                  "telefone": "38890434",
                  "veiculo": {
                      "placa": this.state.placa.match(/\w/g).join(""),
                      "marca": this.state.marcaCarro,
                      "modelo":this.state.modeloCarro,
                      "anoFabricacao": this.state.anoFabricacao,
                      "modeloAno": this.state.modeloAno
                  }
              },
              "parceria": {
                  "idParceria": this.state.idParceria
              }
          }
      }

      console.log('AQUI STATE ', this.state)

        axios.post('https://prod.apisemparar.com.br/condominio-parceiros/v1/clientefreemium/cadastrar', data2, config)
          .then(res => {

            if(res.data.status.codigoRetorno == '-1') {
              this.setState({ sucesso: false });
            }

            this.setState({ sucesso: true });
            this._next();

            console.log('RES DATA ', res.data)
            console.log('RES STATUS ', res.status)
          }).catch(
            function(err) {
              if(err.request.response) {
                var m = JSON.parse(err.request.response);
                this.mensagemError(m.status.mensagem);
              }else {
                this.mensagemError(`"Identificador ${this.state.numberTag} vinculado a contrato ativo"`);
              }
            }.bind(this)
          );
      }
    }
    return;
  }

  /************** FILTROS *****************************/
  filtraCPF(str) {
    return str.replace(/[^0-9]+/g, "");
  }

  /************** FORMULARIO STEP 1 *******************/
  isForm1Empty = ({
    cpf,
    //rg,
    nomeCompleto,
    email,
    telefone,
    placa,
    modeloCarro,
    marcaCarro,
    corCarro
  }) => {
    return (
      !cpf.length ||
      //!rg.length ||
      !nomeCompleto.length ||
      !email.length ||
      !telefone.length ||
      !placa.length ||
      !modeloCarro.length ||
      !marcaCarro.length ||
      !corCarro.length
    );
  };

  isForm1Valid = () => {

    if (this.isForm1Empty(this.state)) {
      //throw error
      this.mensagemError("Todos os campos são obrigatórios!");
      return false;
    } else if (!this.validaCPF(this.state.cpf)) {
      this.mensagemError("CPF inválido!");
      return false;
    }
    // else if(!this.validaRG(this.state.rg)){
    //     this.mensagemError('RG é obrigatório!')
    //     return false;
    // }
    else if (!this.validaEmail(this.state.email)) {
      this.mensagemError("Email inválido!");
      return false;
    } else if (!this.validaTelefone(this.state.telefone)) {
      this.mensagemError("Telefone inválido!");
      return false;
    } else if (!this.validaPlaca(this.state.placa)) {
      this.mensagemError("Placa inválida!");
      return false;
    } else {
      return true;
    }
  };

  handleSubmitStep1 = event => {
    event.preventDefault();

    if (this.isForm1Valid()) {
      this._next();
    }
  };

  /************** FORMULARIO STEP 2 *******************/
  isForm2Empty = ({ numberTag }) => {
    return !numberTag.length;
  };

  isForm2Valid = () => {
    if (this.isForm2Empty(this.state)) {
      //throw error
      this.mensagemError("É obrigatório o preenchimento com número da Tag");
      return false;
    }

    return true;
  };

  handleSubmitStep2 = event => {
    event.preventDefault();
    if (this.isForm2Valid()) {
      this.validaTag(this.state.numberTag);
    }
  };

  setNumberTag = data => {
    this.setState({
      numberTag: data
    });
  };

  /*********************** REQUEST ********************/
  postFormData = () => {
    this.getData()
      .then(res => {
        if (res) {
          this.setState({ sucesso: true });
        } else {
          this.setState({ sucesso: false });
        }
        this._next();
      })
      .catch(err => {
        console.log("error");
      });
  };

  async getData() {
    try {
      const API_KEY = process.env.REACT_APP_X_API_KEY;
      const URL = process.env.REACT_APP_URL;

      const headers = {
        "Content-Type": "application/json",
        "x-api-key": API_KEY
      };

      var data = JSON.stringify({
        acao: this.state.acao,
        nomeCondominio: this.state.nomeCondominio,
        cpf: this.filtraCPF(this.state.cpf),
        rg: this.state.rg.replace('.', '').replace('.', '').replace('-', ''),
        nomeCompleto: this.state.nomeCompleto.toUpperCase(),
        email: this.state.email,
        telefone: this.state.telefone,
        placa: this.state.placa.replace('-', ''),
        tag: this.state.numberTag,
        marcaInfo: this.state.marcaInfo,
        modeloInfo:this.state.modeloInfo,
        corInfo:this.state.corInfo
      });

      this.mensagemInfo("Processando... Aguarde!");

      if(this.state.acao === "i" && this.state.updateCompo === false){

        this.setState({ updateCompo: true })
        const resp = await axios.post(URL, data, {
            headers: headers
          })
          .then(res => {
            this.setState({ response: true })
            return this.state.response;
          })
          .catch(
            function(err) {
              this.mensagemError(err.response.data.result);
              return false;
            }.bind(this)
          );
        return resp;
      }else if(this.state.acao === "u" && this.state.updateCompo === true) {

        this.setState({ updateCompo: false })
        let res = await axios.post(URL, data, {
          headers: headers
        })
        .then(res => {
          this.setState({ response: true })
          return this.state.response;
        })
        .catch(
          function(err) {
            return false;
          }
        );
        return res;
      }else{
        return this.state.response;
      }

    } catch (error) {
      this.mensagemError(
        "Não foi possível efetuar o cadastro, por favor verifique se os dados estão corretos e tente novamente. Se persistir o erro, entre em contato com seu administrador."
      );
      return this.state.response;
    }
  }

  /***************** SYSTEM FUNCTIONS *****************/
  componentDidMount2() {
    //v1.0.0
    console.log("v 1.0.2", sessionStorage.getItem('storagedToken'));
    this.inputSelectMarca();
    this.inputSelectCor();

    const user = this.context;
    if(user.currentUser.email.includes('iprop')) {
      this.setState({
        codLoja: "11572"
      });
    }else if(user.currentUser.email.includes('tidalis')) {
      this.setState({
        codLoja: "11365",
        idParceria: 1
      });

    }else if(user.currentUser.email.includes('wntecnologia')) {
      this.setState({
        codLoja: "11365",
        idParceria: 1
      });
    }else if(user.currentUser.email.includes('allabella')) {
      this.setState({
        codLoja: "11685"
      });
    } else if(user.currentUser.email.includes('fleetcor')) {
      console.log('AQUI FLEETCOR')
      this.setState({
        codLoja: "11111",
        idParceria: 2
      });
    } else {
      //DEFAULT CODE STORE
      this.setState({
        codLoja: "11508"
      });
    }
  }

  componentDidMount() {
    //v1.0.0
    console.log("v 1.0.2", );
    this.inputSelectMarca();
    this.inputSelectCor();

    const user = this.context;
    const session = JSON.parse(sessionStorage.getItem('storagedToken'));

    this.setState({
      codLoja: session.codLoja,
      idParceria: session.idParceria
    });
    // axios.get('https://prod.apisemparar.com.br/condominio-parceiros/v1/parceiros/listar', {
    //   headers: {
    //       'x-api-key': 'flA2resqZ43x2E1k5uYOBGjfCiMwtAV1v2vsTjtc'
    //   }
    // })
    // .then(res => {
    //     const lojas = res.data;
    //     var codLoja = "11508";
    //     var parceiro = 0;

    //     Object.keys(lojas).forEach(function(key) {

    //       if(user.currentUser.email.includes(lojas[key]['dadosParceria']['nome'].toLowerCase().replace(/ /g, ""))) {
    //         codLoja = lojas[key]['dadosParceria']['idPontoVenda'];
    //         parceiro = lojas[key]['idParceria']
    //       }

    //       if(user.currentUser.email.includes('iprop')) {
    //         codLoja = "11572";
    //         parceiro = 2;
    //       }

    //       if(user.currentUser.email.includes('tidalis')) {
    //         codLoja = "11365"
    //         parceiro = 1;
    //       }

    //       if(user.currentUser.email.includes('fleetcor')) {
    //         codLoja = "11365"
    //         parceiro = 1;
    //       }
    //     });

    //     this.setState({
    //       codLoja: codLoja,
    //       idParceria: parceiro
    //     });
    // })
    // .catch(error => {
    //     setTimeout(() => {
    //         this.setState({ open: false });
    //         this.mensagemError("Por favor verifique se os dados estão corretos e tente novamente. Se persistir o erro, entre em contato com seu administrador.");
    //     }, 2050)
    // });
  }
  componentDidUpdate(){

    console.log('codLoja', this.state.codLoja);
    console.log('idParceira ', this.state.idParceria)
    if(this.state.acao === "u" && this.state.updateCompo === false){
       this.inputSelectModelo();
       this.setState({
        updateCompo:true
      })
    }
  }

  render() {
    return (
      <React.Fragment>
        <div className="screenBackground">
          <div>
            <Step1
              acao={this.state.acao}
              currentStep={this.state.currentStep}
              handleChange={this.handleChange}
              handleSubmitStep1={this.handleSubmitStep1}
              _next={this._next}
              nomeCondominio={this.state.nomeCondominio}
              nomeCompleto={this.state.nomeCompleto}
              cpf={this.state.cpf}
              rg={this.state.rg}
              cep={this.state.cep}
              email={this.state.email}
              telefone={this.state.telefone}
              placa={this.state.placa}
              marcaCarro={this.state.marcaCarro}
              modeloCarro={this.state.modeloCarro}
              corCarro={this.state.corCarro}
              updateTag={this.state.updateTag}
              optionsMarcas={this.state.optionsMarcas}
              optionsModelos={this.state.optionsModelos}
              optionsCores={this.state.optionsCores}
              inputSelectModelo={this.inputSelectModelo}
              inputSelectCor={this.inputSelectCor}
              inputColorSelected={this.inputColorSelected}
              functionCallFromParent={this.getDataUpdate.bind(this)}
              dataCep={this.state.dataCep}
            />

            <Step2
              currentStep={this.state.currentStep}
              handleChange={this.handleChange}
              handleSubmitStep2={this.handleSubmitStep2}
              _next={this._next}
              _prev={this._prev}
              numberTag={this.numberTag}
              setNumberTag={this.setNumberTag}
              acao={this.state.acao}
            >
            <Form.Input
              fluid
              onChange={this.handleChange}
              name="numberTag"
              id="numberTag"
              icon="barcode"
              iconPosition="left"
              placeholder="Número da TAG"
              type="text"
              value={this.state.numberTag}
            />
            </Step2>

            <Step3
              currentStep={this.state.currentStep}
              _prev={this._prev}
              defaultPage={this.defaultPage}
              newPage={this.newPage}
              sucesso={this.state.sucesso}
              acao={this.state.acao}
            />
          </div>

          <Toaster />
        </div>
      </React.Fragment>
    );
  }
}

export default NewMasterForm;
